<template>
  <div>
    <div v-if="mode === 'create'">
      <v-btn
        :disabled="disabled"
        icon
        fab
        @click="setDialog(true)"
        color="primary"
        title="Create New Address"
        alt-text="Create New Address"
      >
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </div>
    <div v-if="mode === 'edit'">
      <v-btn
        :disabled="disabled"
        icon
        fab
        @click="setDialog(true)"
        color="primary"
        title="Edit Address"
        alt-text="Edit Address"
      >
        <v-icon>fas fa-pencil-alt</v-icon>
      </v-btn>
    </div>
    <v-dialog v-model="dialog" max-width="600" persistent>
      <address-form
        :addressId="addressId"
        :mode="mode"
        @setAddressId="setAddressId"
        @setDialog="setDialog"
      ></address-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import AddressForm from "@/components/static/AddressForm";

export default {
  components: { AddressForm },
  computed: {
    addressId() {
      return this.value;
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    ...mapActions({
      fetchRecord: "address/get",
    }),
    setAddressId(val) {
      this.$emit("input", val);
    },
    setDialog(val) {
      this.dialog = val;
    },
  },
  notifications: {
    notifyErrorAddressFetch: {
      title: "Error",
      message: "Could not fetch details for selected address.",
      type: "warn",
    },
  },
  props: ["disabled", "mode", "value"],
  watch: {
    async dialog() {
      if (this.mode === "edit" && this.dialog === true) {
        try {
          await this.fetchRecord(this.addressId);
        } catch (e) {
          // eslint-disable-next-line
          console.error(e);
          this.notifyErrorAddressFetch();
        }
      }
    },
  },
};
</script>
